import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _PropTypes from 'prop-types';
import { useToasts } from './ToastsContext.js';
import { jsx } from 'react/jsx-runtime';

function ToastsWithHOC(Component) {
  var InjectedUseToasts = function InjectedUseToasts(props) {
    var toastsHelpers = useToasts();
    return /*#__PURE__*/jsx(Component, _objectSpread(_objectSpread({}, props), {}, {
      useToasts: toastsHelpers
    }));
  };

  return InjectedUseToasts;
}

function ToastsWithRenderProps(_ref) {
  var children = _ref.children;
  var toastsHelpers = useToasts();
  return children(toastsHelpers);
}

ToastsWithRenderProps.propTypes = {
  "children": _PropTypes.func.isRequired
};

export { ToastsWithHOC, ToastsWithRenderProps };
